import React, { useEffect } from 'react';
import classes from './ModalEditCredential.module.scss';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { ModalConfig } from 'new/routes/RouterManager';
import CredentialForm from 'js/components/credentials/CredentialFormContainer';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { PROBE_CREDENTIAL_REQUEST, UPDATE_CREDENTIAL_REQUEST } from 'js/constants/actionTypes';

interface ModalAddCredentialProps {
  credentialId: number;
  selectedTemplate?: string;
  onSaveCredential?: () => Promise<any>;
  onChangeTemplate?(id: string): void;
}

export const ModalEditCredential = (props: ModalAddCredentialProps & Partial<ModalOutProps>) => {
  const { credentialId, onSaveCredential, setLoading, setModalActions } = props;
  const loading = useIsLoading(UPDATE_CREDENTIAL_REQUEST, PROBE_CREDENTIAL_REQUEST);

  useEffect(() => {
    setModalActions({
      ok: {
        text: 'Save',
        onClick: onSaveCredential,
      },
    });
  }, [onSaveCredential]);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  return (
    <div className={classes.modalContainer}>
      <CredentialForm
        selectedTemplate={props.selectedTemplate}
        onChangeTemplate={props.onChangeTemplate}
        credentialId={credentialId}
        isPopUpForm={true}
        renderFooter={() => null}
        inModal={true}
      />
    </div>
  );
};

ModalEditCredential.modalConfig = {
  name: 'ModalAddCredential',
  title: 'Add new credential',
} as ModalConfig;
